import "@fontsource-variable/inter";
import "@fontsource-variable/jetbrains-mono";
import "../styles.css";
import "./webmail.css";

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { MutationCache, QueryCache, QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { createBrowserRouter, RouterProvider } from "react-router";
import { TooltipProvider } from "../ui/Menu";
import { ToastProvider } from "../ui/Toast";
import { ApiError } from "./api";
import { App } from "./App";
import { applyCachedBrand } from "../lib/brand";

// The last brand this browser saw here, before the first paint (an agency's webmail shouldn't flash Hosterr orange).
applyCachedBrand();

const queryClient = new QueryClient({
  queryCache: new QueryCache(),
  mutationCache: new MutationCache(),
  defaultOptions: {
    queries: {
      staleTime: 20_000,
      refetchOnWindowFocus: true,
      // Retry only when webmail or the network is down; a 4xx won't change on retry.
      retry: (count, err) => err instanceof ApiError && (err.status === 0 || err.code === "unavailable") && count < 2,
    },
    mutations: { retry: false },
  },
});

// In dev webmail lives at /webmail/ beside the panel; on its own origin it's at /.
const basename = location.pathname.startsWith("/webmail") ? "/webmail" : "/";
const router = createBrowserRouter([{ path: "*", element: <App /> }], { basename });

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <TooltipProvider delayDuration={400}>
        <ToastProvider>
          <RouterProvider router={router} />
        </ToastProvider>
      </TooltipProvider>
    </QueryClientProvider>
  </StrictMode>,
);
